import { Controller } from '@hotwired/stimulus';

// The inline show/hide word of a password field (PasswordRevealHelper). Only
// the type and the word move; name, id and autocomplete stay on the input.
export default class extends Controller {
  static targets = ['button'];
  static values = { show: String, hide: String };

  connect() {
    if (this.input.id) this.buttonTarget.setAttribute('aria-controls', this.input.id);
  }

  toggle() {
    this.reveal(this.input.type === 'password');
  }

  // turbo:before-cache (the helper's data-action): a snapshot is never revealed.
  hide() {
    this.reveal(false);
  }

  reveal(on) {
    this.input.type = on ? 'text' : 'password';
    this.buttonTarget.textContent = on ? this.hideValue : this.showValue;
    this.buttonTarget.setAttribute('aria-pressed', on);
  }

  get input() {
    return this.element.querySelector('input');
  }
}
